export default "__VITE_ASSET__2e830133__"